import AlphaLastNameFilter from 'components/Common/Filter/AlphaLastNameFilter';

const getAlphaLastNameFilter = () => ({
  key: 'alphaLastName',
  source: 'alphaLastName',
  searchable: false,
  selector: 'name',
  label: 'alphaLastName',
  isEnabled: true,
  filterName: 'Alpha last name',
  ComponentClass: AlphaLastNameFilter,
});

export default getAlphaLastNameFilter;
